export default __webpack_public_path__ + "static/pragicts-ai-planning-2868f09c08da0d60e0ccff14d2304944.jpg";